import { InjectionToken } from '@angular/core';

/**
 * Opens a Keycloak URL in a popup (e.g. an Electron child window) and resolves
 * with the redirect URL it ended on — or `null` if the user closed it. When
 * provided, `AuthService` runs login / register / logout through it instead of
 * redirecting the app itself; apps that can't redirect (Electron over
 * `file://`) need this. `redirectUri` must then be the URL the popup watches for.
 */
export type EsAuthPopup = (url: string) => Promise<string | null>;

export const ES_AUTH_POPUP = new InjectionToken<EsAuthPopup>('ES_AUTH_POPUP');
